module.exports = __webpack_public_path__ + "img/ILOILO.1e6d8b42.jpg";